import { useMemo } from 'react';

import type { InventoryTabItemName } from '../InventoryStore';
import type { FieldFormatterKey } from '../utils/fieldFormatters';
import { getFieldFormatter } from '../utils/fieldFormatters';

import { useDuplicateCallback } from './useDuplicateCallback';
import { useRowState } from './useRowState';

type UseRowConfigParams = {
  entityId: number;
  entityType: InventoryTabItemName;
  fieldName: string;
  formatterName?: FieldFormatterKey;
};

export const useRowConfig = ({
  entityId,
  entityType,
  fieldName,
  formatterName,
}: UseRowConfigParams) => {
  const rowState = useRowState(entityType);

  const onDuplicate = useDuplicateCallback(entityType, entityId, fieldName);

  const formatter = useMemo(
    () => (formatterName ? getFieldFormatter(formatterName) : undefined),
    [formatterName]
  );

  return {
    ...rowState,
    formatter,
    onDuplicate,
  };
};
